import { FormikProps } from 'formik';
import QuestionnaireScreen, { deserializeResponses, serializeResponses } from '../../QuestionnaireScreen';
import { Body } from '../../GridLayout';
import { SubtitleText, TitleText } from '../../../controls/helpers';
import KiwiSaverCalculator, { CompareType, EmploymentStatus } from '../../../kiwiSaverCalculator/KiwiSaverCalculator';
import { useRiskProfile, useEmployed, usePlanningToWithdraw } from './BeginQuestions';
import { InvestmentOptions } from '../../../../api';
import { riskOptions } from '../../../../common/types';
import { useAppSelector } from '../../../../store';

const question = {
    age: 'Age',
    income: 'Income',
    kiwiSaverBalance: 'KiwiSaver balance'
};

export const getAge = () => {
    const { responses } = useAppSelector(state => state.clientQuestionnaires);
    const { age } = deserializeResponses(question)(responses || {});
    return age;
}

export const getIncome = () => {
    const { responses } = useAppSelector(state => state.clientQuestionnaires);
    const { income } = deserializeResponses(question)(responses || {});
    return income;
}

export const getKiwiSaverBalance = () => {
    const { responses } = useAppSelector(state => state.clientQuestionnaires);
    const { kiwiSaverBalance } = deserializeResponses(question)(responses || {});
    return kiwiSaverBalance;
}

const Calculator = () => {
    const employmentStatus = useEmployed() ? EmploymentStatus.Employed : EmploymentStatus.SelfEmployed;
    const lowRiskProfile = useRiskProfile() === riskOptions.low;
    const isWithdrawing = usePlanningToWithdraw();
    const compareType = !isWithdrawing && !lowRiskProfile ? employmentStatus === EmploymentStatus.Employed ? CompareType.ContributionPercent : CompareType.ContributionDollars : CompareType.Strategies;
    return <QuestionnaireScreen
        initialValues={{ income: undefined, age: undefined, kiwiSaverBalance: undefined }}
        deserializeResponses={deserializeResponses(question)}
        serializeResponses={serializeResponses(question)}>
        {(formik: FormikProps<any>) => {
            return <Body isNarrowView>
                <TitleText>Maximising the contribution you make to your investments will boost your retirement balance.</TitleText>
                <SubtitleText>Did you know that research shows most Kiwis need to save 9% of their income for a successful retirement?</SubtitleText>
                <KiwiSaverCalculator
                    investmentOption={!isWithdrawing && !lowRiskProfile ? InvestmentOptions.LifeCycle : InvestmentOptions.SelfSelect}
                    compareType={compareType}
                    annualIncome={formik.values?.income}
                    employmentStatus={employmentStatus}
                    updateAnnualIncome={annualIncome => annualIncome && formik.setFieldValue('income', annualIncome)}
                    updateAge={age => age && formik.setFieldValue('age', age)}
                    updateKiwiSaverBalance={kiwiSaverBalance => kiwiSaverBalance && formik.setFieldValue('kiwiSaverBalance', kiwiSaverBalance)}
                />
            </Body>
        }}
    </QuestionnaireScreen>
}

export default Calculator;
